export default $wire => ({
    definitionOpen: $wire.entangle('definitionOpen').live,
    init() {
        $wire.load();
    },
});
